import { string } from "yup";

const nameRegex = /^[a-zA-Zа-яА-Я-]{1,15}$/;
const lastnameRegex = /^[a-zA-Zа-яА-Я-]{1,25}$/;
const middlenameRegex = /^[a-zA-Zа-яА-Я-]{1,20}$/;
const passRegex = /^(?=.*\d)(?=.*[a-zA-Z]).{8,100}$/;

export const firstNameSchema = string().matches(nameRegex, {
  excludeEmptyString: true,
  message: "first_name",
});
export const lastNameSchema = string().matches(lastnameRegex, {
  excludeEmptyString: true,
  message: "last_name",
});
export const middleNameSchema = string().matches(middlenameRegex, {
  excludeEmptyString: true,
  message: "middle_name",
});
export const passwordSchema = string().matches(passRegex, {
  excludeEmptyString: true,
  message: "password_regex",
});
